import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FloatingWhatsApp } from "@/components/WhatsAppButton";
import { BrandMark } from "@/brand/BrandMark";

export default function Login() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleLogin = () => {
    // F-MOTOR-RESERVAS.3.0 — Admin passou para /admin. Após login, retorna direto ao painel.
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#F5F1E8] flex items-center justify-center px-6 relative overflow-hidden">
      {/* Marca d'água decorativa oficial */}
      <div className="brand-watermark top-[-80px] right-[-80px]">
        <BrandMark variant="mark" size={480} />
      </div>
      <div className="brand-watermark bottom-[-100px] left-[-100px] opacity-[0.04]">
        <BrandMark variant="mark" size={420} />
      </div>

      <div className="max-w-md w-full relative">
        <div className="bg-[#FFFFFF] border border-stone-200 rounded-lg p-10 shadow-sm">
          <div className="flex items-center gap-4 mb-10">
            <BrandMark variant="full" size={56} />
          </div>

          <div className="mb-8">
            <div className="text-[11px] uppercase tracking-[0.25em] text-[#D4A652] mb-3 font-semibold flex items-center gap-2">
              <ShieldCheck size={12} /> Acesso restrito
            </div>
            <h1 className="font-brand-title text-2xl text-stone-900 leading-tight font-bold">
              Entre para gerenciar suas pousadas.
            </h1>
            <p className="text-stone-600 mt-3 text-sm leading-relaxed">
              Apenas o administrador autorizado consegue acessar o painel. Hóspedes utilizam a página pública de check-in.
            </p>
          </div>

          <Button
            data-testid="btn-login"
            onClick={handleLogin}
            className="w-full h-12 bg-[#083A6B] hover:bg-[#052B50] text-white text-sm rounded-md"
          >
            Entrar com Google
          </Button>

          <p className="text-xs text-stone-500 mt-6 text-center">
            Contas não autorizadas serão bloqueadas automaticamente.
          </p>
        </div>

        <div className="text-center mt-8 text-xs text-stone-500">
          Precisa de ajuda? Fale conosco no WhatsApp
        </div>
      </div>

      <FloatingWhatsApp />
    </div>
  );
}
